// The Growth Journey - Main Application Entry Point

// Import Tailwind CSS for SSG components
import "./styles/globals.css";

// Import application modules
import { NavigationManager } from "./modules/navigation";
import { FormManager } from "./modules/form-manager";
import { AnimationManager } from "./modules/animation-manager";
import { PerformanceManager } from "./modules/performance-manager";

// Application class to orchestrate all modules
class GrowthJourneyApp {
  private navigation: NavigationManager;
  private formManager: FormManager;
  private animationManager: AnimationManager;
  private performanceManager: PerformanceManager;

  constructor() {
    this.navigation = new NavigationManager();
    this.formManager = new FormManager();
    this.animationManager = new AnimationManager();
    this.performanceManager = new PerformanceManager();
  }

  // Method to get access to individual managers if needed
  public getManagers() {
    return {
      navigation: this.navigation,
      formManager: this.formManager,
      animationManager: this.animationManager,
      performanceManager: this.performanceManager,
    };
  }
}

// Initialize the application
const app = new GrowthJourneyApp();

// Export app instance for potential external access
export default app;
